import React from "react";
import { Accordion } from "react-bootstrap";
import PracticeSetItem from "./PracticeSetItem";
import "./TopicItem.css";

const TopicItem = ({
  topic,
  roleOfTheUser,
  classroomId,
  activeTab,
  hasValidSubscription,
  onPracticeStart,
  selected,
  focusedExam,
  isMobile = false,
}) => {
  // Helper to check if all practice sets and tests are attempted
  const isValidScore = (score) => typeof score === "number" && !isNaN(score);

  const allPracticesAttempted = Array.isArray(topic?.practices)
    ? topic.practices.length > 0 &&
      topic.practices.every((p) => isValidScore(p.score))
    : true; // If no practices, treat as true

  const allTestsAttempted = Array.isArray(topic?.tests)
    ? topic.tests.length > 0 && topic.tests.every((t) => isValidScore(t.score))
    : true; // If no tests, treat as true

  const hasAnySets =
    (Array.isArray(topic?.practices) && topic.practices.length > 0) ||
    (Array.isArray(topic?.tests) && topic.tests.length > 0);

  const allAttempted = hasAnySets && allPracticesAttempted && allTestsAttempted;

  const topicScore =
    typeof topic.score === "string" ? parseFloat(topic.score) : topic.score;

  let badge = null;
  if (allAttempted) {
    if (topicScore >= 90) badge = "Champion";
    else if (topicScore > 60 && topicScore < 90) badge = "Challenger";
    else badge = "Rookie";
  } else {
    if (topicScore > 60) badge = "Challenger";
    else badge = "Rookie";
  }

  if (isMobile) {
    // Only render practice sets, no badge or inner accordion/header
    return (
      <div className="mb-4" id={topic?._id}>
        {topic?.practices?.length ? (
          <div>
            {topic?.practices.map((practice, practiceInd) => (
              <PracticeSetItem
                key={practiceInd}
                practice={practice}
                onStart={() => onPracticeStart(topic?._id, practice)}
                roleOfTheUser={roleOfTheUser}
                classroomId={classroomId}
                activeTab={activeTab}
                practiceInd={practiceInd}
                hasValidSubscription={hasValidSubscription}
                focusedExam={focusedExam}
              />
            ))}
          </div>
        ) : (
          <p
            className="px-4 py-3"
            style={{ color: "#6E7485", fontSize: "12px" }}
          >
            No practices found.
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="mb-4 d-flex align-items-center" id={topic?._id}>
      <Accordion
        className="categoriesAccordion w-100"
        style={{
          boxShadow: selected ? "0 0 6px rgba(35, 173, 278, 1)" : "none",
          backgroundColor: selected ? "#EBEBFF" : "transparent",
          transition: "all 0.3s ease",
        }}
      >
        <Accordion.Item className="bg-white">
          <Accordion.Header>
            <div className="d-flex flex-column bg-white p-2">
              <div className="d-flex align-items-center gap-2">
                <strong style={{ fontSize: "20px" }}>{topic?.name}</strong>
                {/* Show badge only if all attempted */}
                {badge && (
                  <span className={`topic-badge ${badge.toLowerCase()}`}>
                    {badge}
                  </span>
                )}
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body className="p-0">
            {topic?.practices?.length ? (
              <div>
                {topic?.practices.map((practice, practiceInd) => (
                  <PracticeSetItem
                    key={practiceInd}
                    practice={practice}
                    onStart={() => onPracticeStart(topic?._id, practice)}
                    roleOfTheUser={roleOfTheUser}
                    classroomId={classroomId}
                    activeTab={activeTab}
                    practiceInd={practiceInd}
                    hasValidSubscription={hasValidSubscription}
                    focusedExam={focusedExam}
                  />
                ))}
              </div>
            ) : (
              <p
                className="px-4 py-3"
                style={{ color: "#6E7485", fontSize: "12px" }}
              >
                No practices found.
              </p>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default TopicItem;
